<div class="d-flex flex-column">
  <ag-grid-angular #agGrid class="w-100" style="height: 300px;" class="ag-theme-balham" (gridReady)="onGridReady($event)"
    [gridOptions]="findProjectScheduleGridOptions" (rowSelected)="onRowSelected($event)">
  </ag-grid-angular>
</div>

<kendo-dialog-actions class="ps-0 pe-0 border-0">
  <button type="button" kendoButton (click)="onCloseDialog()">Cancel</button>
  <button type="button" kendoButton themeColor="primary" (click)="updateSchedule()" [disabled]="selectedRows.length === 0">Update Schedule</button>
</kendo-dialog-actions>